export const userActivePlan = payload => ({
    type: 'USER_ACTIVE_PLAN',
    payload: payload
})
